import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, useTheme, IconButton
} from '@mui/material';
import { IoMdClose } from "react-icons/io";
import { useQuantityDPRMutation } from 'store/slices/apis/wbsLevelSlice';
import { useNavigate, useParams } from 'react-router-dom';


const ConfirmationDuantityDPR = ({ open, onClose, openNotification, data }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const [quantityDPRFun, quantityDPRRes] = useQuantityDPRMutation();
    const handleproceed = async () => {
        await quantityDPRFun(data)
    }

    React.useEffect(() => {
        if (quantityDPRRes?.isSuccess) {
            if (quantityDPRRes?.data?.status?.toLowerCase() == 'success') {
                onClose();
                navigate(`/projects/${projectId}/dpr/Quantity_list`);
                openNotification(quantityDPRRes?.data?.message, 'success')
            } else {
                openNotification(quantityDPRRes?.data?.message, 'error')
            }
        }
    }, [quantityDPRRes?.isSuccess]);

    React.useEffect(() => {
        if (quantityDPRRes?.isError) {
            if (quantityDPRRes?.error?.data?.status == 'fail') {
                openNotification(quantityDPRRes?.error?.data?.message, 'error')
            } else {
                openNotification(quantityDPRRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [quantityDPRRes?.isError]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <div style={{ position: "relative" }}>
                <DialogTitle>Confirmation</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: "20px" }} />
                </IconButton>
                <DialogContent sx={{ mt: "20px" }}>
                    Are you sure you want to submit?
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        loading={quantityDPRRes?.isLoading}
                        onClick={handleproceed}
                        sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                        }}
                    >
                        Proceed
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default ConfirmationDuantityDPR;
